module.exports = __webpack_public_path__ + "img/insurance-per-days.svg";